import React, { useContext, useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import RequestedESignContract from './RequestedESignContract';
import StageTwoTimerCommencedAgent from './StageTwoTimerCommencedAgent';
import WinnerPendingBannerAgent from './WinnerPendingBannerAgent';
import Step1PrepareContractESign from './AgentESignBanners/Step1PrepareContractESign';
import Step2BuyerSignaturePendingAgent from './AgentESignBanners/Step2BuyerSignaturePendingAgent';
import Step3BuyerSignedContractAgentBanner from './AgentESignBanners/Step3BuyerSignedContractAgentBanner';
import Step4VendorContractESignNowAgent from './AgentESignBanners/Step4VendorContractESignNowAgent';
import Step5VendorSignaturePendingAgent from './AgentESignBanners/Step5VendorSignaturePendingAgent';
import DepositPaymentOutstandingBanner from './DepositPaymentOutstandingBanner';
import DepositPaymentReceivedBannerAgent from './DepositPaymentReceivedBannerAgent';
import ConfirmExchangeComplete from './ConfirmExchangeComplete';
import ConfirmSettlementCompleted from './ConfirmSettlementCompleted';
import CongratulationSettlementCompleted from './CongratulationSettlementCompleted';
import Step6VendorSignedContractOfSale from './AgentESignBanners/Step6VendorSignedContractOfSale';
import dayjs from 'dayjs';
import DetailsPopup from 'component/VendorStatusContainer/DepositManager/StatusDetailsPopups/DetailsPopup';
import Requestdeposit from 'component/BuyerRegistration/components/RequestDepositPopup';
import { datacontext } from 'modules/AppLayout/AppLayout';
import 'swiper/swiper-bundle.min.css';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper';
SwiperCore.use([Autoplay, Pagination, Navigation]);

const IndexAgentBanners = (props) => {
  let {
    // Dashboard Data
    isAgentDashboard,

    // Individual-Active
    profileDetails,
    isIndividualForMargin,
    getListInfo,
    isAgentIndividual,
    setOpenExchange,
    setShowExchange,
    setOpenSettlement,
    setShowSettlement,
    getBannerData,
    bannerData,

    // banner states
    setOpenCommenceStageTwo,
    setOpenFromBannerNominateWinner,
    propertyId,
    confirmDeposit,
    setConfirmDeposit,
  } = props;

  const { realTimeLog } = useContext(datacontext);

  useEffect(() => {
    getBannerData();
  }, [getBannerData, realTimeLog, propertyId]);

  const [calculatedTime, setCalculatedTime] = useState();

  const [congratulationsettlementClose, setCongratulationsettlementClose] =
    useState([]);
  const [outstandingBannerClose, setOutstandingBannerClose] = useState([]);
  const [requestEsignBannerClose, setRequestEsignBannerClose] = useState([]);
  const [signedContractBannerClose, setSignedContractBannerClose] = useState(
    []
  );
  const [vendorSignedContractClose, setVendorSignedContractClose] = useState(
    []
  );

  const getShouldShowSettlementBanner = (value) => {
    const exchangedAtStr = value?.exchangedStatus?.exchangedAt;
    const settlementDays = value?.exchangedStatus?.settlementDays ?? 0;

    if (!exchangedAtStr) return false;

    const exchangedAt = dayjs.tz(
      exchangedAtStr,
      'YYYY-MM-DD HH:mm:ss',
      'Australia/Sydney'
    );
    const totalHours = (settlementDays + 1) * 24;
    const targetTime = exchangedAt.add(totalHours, 'hour');

    const resumeAtStr = value?.cancelActionDetails?.resumeAt;

    const resumeAtSydney = resumeAtStr
      ? dayjs.tz(resumeAtStr, 'YYYY-MM-DD HH:mm:ss', 'Australia/Sydney')
      : null;

    const nowSydney = dayjs().tz('Australia/Sydney');

    const resumeTime =
      resumeAtSydney &&
      (nowSydney.isAfter(resumeAtSydney) || nowSydney.isSame(resumeAtSydney));
    const firstTimeDisplay =
      nowSydney.isAfter(targetTime) || nowSydney.isSame(targetTime);

    return resumeAtStr == null || resumeAtStr == undefined
      ? firstTimeDisplay
      : resumeTime;
  };

  // exchanged time calculation

  const exchangedTimeCalc = (value) => {
    const nowSydney = dayjs().tz('Australia/Sydney');
    const resumeAtStr = value;

    const resumeAtSydney = dayjs.tz(
      resumeAtStr,
      'YYYY-MM-DD HH:mm:ss',
      'Australia/Sydney'
    );

    const resumeTime =
      nowSydney.isAfter(resumeAtSydney) || nowSydney.isSame(resumeAtSydney);
    return resumeTime;
  };

  useEffect(() => {
    if (!bannerData) return;

    const show = getShouldShowSettlementBanner(bannerData);
    setCalculatedTime(show);
  }, [bannerData]);

  const [settlementVisibility, setSettlementVisibility] = useState({});

  useEffect(() => {
    if (!isAgentDashboard || !bannerData) return;

    const visibility = {};
    Object.entries(bannerData)?.forEach(([key, item]) => {
      visibility[key] = getShouldShowSettlementBanner(item);
    });
    setSettlementVisibility(visibility);
  }, [bannerData, isAgentDashboard]);

  const [depositdetails, setDepositdetails] = useState(false);
  const [requestdeposit, setRequestdeposit] = useState(false);

  const [reqDepositOpen, setReqDepositOpen] = useState(false);
  const [
    endPropertyPopupFromNominateWinner,
    setEndPropertyPopupFromNominateWinner,
  ] = useState(false);

  const propertyOfferId = profileDetails?.PropertyDetails?.highestOfferId;

  const matchedOffer = profileDetails?.BuyerRegisterDetails?.find(
    (item) => item?.buyerOfferDetails?.propertyOfferId === propertyOfferId
  );

  const matchedBuyer = profileDetails?.BuyerRegisterDetails?.find(
    (item) => item?.buyerOfferDetails?.propertyOfferId === propertyOfferId
  );

  const nominateWinnerBannerBuyerId = bannerData?.highestOfferBuyerId;

  const buyerId =
    depositdetails || requestdeposit
      ? nominateWinnerBannerBuyerId
      : matchedBuyer?.buyerDetails?.user?.userId;

  const [selectedrowbuyername, setSelectedrowbuyername] = useState('');

  useEffect(() => {
    if (requestdeposit && matchedBuyer?.buyerDetails?.user) {
      const { userName = '', userSurName = '' } =
        matchedBuyer.buyerDetails.user;
      setSelectedrowbuyername(`${userName} ${userSurName}`.trim());
    }
  }, [requestdeposit, matchedBuyer]);

  const isRequestDepositCompleted =
    Number(bannerData?.offerPrice) ===
      Number(bannerData?.requestedDepositAmount) ||
    Number(matchedOffer?.requestedDepositAmount) ===
      Number(matchedOffer?.buyerOfferPrice);

  const swiperRef = useRef(null);

  const [currentBuyerIndex, setCurrentBuyerIndex] = useState(0);
  const [currentVendorIndex, setCurrentVendorIndex] = useState(0);
  const [pauseBannerBuyer, setPauseBannerBuyer] = useState(false);
  const [pauseBannerVendor, setPauseBannerVendor] = useState(false);

  useEffect(() => {
    let buyerTimer;
    let vendorTimer;

    if (currentBuyerIndex) {
      buyerTimer = setTimeout(() => {
        setPauseBannerBuyer(true);
        setCurrentBuyerIndex(false);
      }, 10000);
    } else {
      setPauseBannerBuyer(false);
    }

    if (currentVendorIndex) {
      vendorTimer = setTimeout(() => {
        setPauseBannerVendor(true);
        setCurrentVendorIndex(false);
      }, 10000);
    } else {
      setPauseBannerVendor(false);
    }

    return () => {
      if (buyerTimer) clearTimeout(buyerTimer);
      if (vendorTimer) clearTimeout(vendorTimer);
    };
  }, [currentBuyerIndex, currentVendorIndex]);

  const swiperKey = `${JSON.stringify(bannerData)}|${JSON.stringify(
    profileDetails
  )}`;

  const owners = bannerData?.propertyOwnerDetails ?? [];

  const shouldShowBannerIndividual =
    owners.length > 0 &&
    owners.every((owner) => {
      const status = owner?.user?.vendorEsignStatus === 'Completed' ?? '';
      return status;
    });

  return (
    <>
      <Swiper
        key={swiperKey}
        ref={swiperRef}
        onMouseEnter={() => swiperRef?.current?.swiper?.autoplay?.stop()}
        onMouseLeave={() => swiperRef?.current?.swiper?.autoplay?.start()}
        onSlideChange={(swiper) => {
          const activeSlideId = swiper.slides[swiper.activeIndex].id;
          setCurrentBuyerIndex(
            activeSlideId === 'Agent_Buyer_Signed_The_Contract_Of_Sale'
          );
          setCurrentVendorIndex(
            activeSlideId === 'Agent_Vendor_Signed_The_Contract_Of_Sale'
          );
        }}
        spaceBetween={30}
        slidesPerView={1}
        centeredSlides={true}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        pagination={{
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 5,
        }}
        className="product-carousel-wrapper"
        navigation={false}
        modules={[Autoplay, Pagination, Navigation]}
        style={{
          borderRadius: '20px',
          marginTop: isAgentIndividual
            ? isIndividualForMargin
              ? '0px'
              : '25px'
            : '20px',
        }}
      >
        {isAgentDashboard && (
          <>
            {Object.entries(bannerData)?.map(([key, item]) => {
              return (
                <div key={`section-${key}`}>
                  {!requestEsignBannerClose.includes(Number(item?.buyerId)) &&
                    item?.isPropertyArchived == 0 &&
                    item?.eSignRequestStatus
                      ?.filter(
                        (item) =>
                          item?.status === 'Requested' &&
                          item?.isTodayEsignRequestedViewed == 0
                      )
                      ?.map((item, index) => (
                        <SwiperSlide
                          key={`slide-offer-${key}-${index}`}
                          style={{ borderRadius: '20px' }}
                        >
                          <RequestedESignContract
                            isAgentDashboard={isAgentDashboard}
                            bannerDetails={item}
                            AgentGroupCall={getBannerData}
                            setRequestEsignBannerClose={
                              setRequestEsignBannerClose
                            }
                          />
                        </SwiperSlide>
                      ))}
                </div>
              );
            })}

            {Object.entries(bannerData)?.map(([key, item]) => {
              return (
                <div key={`section-${key}`}>
                  {item.stage == 'ST1' &&
                    item?.isPropertyArchived == 0 &&
                    item?.isApprovedLog == 1 &&
                    item?.timerStatus !== 'End' && (
                      <SwiperSlide
                        key={`slide-offer-${key}}`}
                        style={{ textAlign: 'none !important' }}
                      >
                        <StageTwoTimerCommencedAgent
                          isAgentDashboard={isAgentDashboard}
                          bannerDetails={item}
                          AgentGroupCall={getBannerData}
                        />
                      </SwiperSlide>
                    )}
                </div>
              );
            })}

            {Object.entries(bannerData)?.map(([key, item]) => {
              // Base conditions
              const baseConditions =
                item?.isWinner === 0 &&
                item?.isPropertyArchived === 0 &&
                item?.highestOffer !== null;

              // Stage 1 completed condition
              const isStage1Completed =
                item?.stage === 'ST1' &&
                item?.isApprovedLog === 1 &&
                item?.timerStatus === 'End';

              // Stage 2 ended condition
              const isStage2Ended =
                item?.stage === 'ST2' && item?.timerStatus === 'End';

              // Render only when base + stage conditions match
              const shouldShowBanner =
                baseConditions && (isStage1Completed || isStage2Ended);

              return (
                <div key={`section-${key}`}>
                  {shouldShowBanner && (
                    <SwiperSlide
                      key={`slide-offer-${key}`}
                      style={{ textAlign: 'none !important' }}
                    >
                      <WinnerPendingBannerAgent
                        isAgentDashboard={isAgentDashboard}
                        bannerDetails={item}
                        AgentGroupCall={getBannerData}
                      />
                    </SwiperSlide>
                  )}
                </div>
              );
            })}

            {Object.entries(bannerData)?.map(([key, item]) => {
              return (
                <div key={`section-${key}`}>
                  {item?.isWinner == 1 &&
                    item?.isPropertyArchived == 0 &&
                    (item?.isWinnerContractSignStatus == 'Action Required' ||
                      item?.isWinnerContractSignStatus == 'Requested') && (
                      <SwiperSlide
                        key={`slide-offer-${key}}`}
                        style={{ textAlign: 'none !important' }}
                      >
                        <Step1PrepareContractESign
                          isAgentDashboard={isAgentDashboard}
                          bannerDetails={item}
                          AgentGroupCall={getBannerData}
                        />
                      </SwiperSlide>
                    )}
                </div>
              );
            })}
            {Object.entries(bannerData)?.map(([key, item]) => {
              return (
                <div key={`section-${key}`}>
                  {item?.isWinner == 1 &&
                    item?.isPropertyArchived == 0 &&
                    item?.isWinnerContractSignStatus ==
                      'Pending Buyer Signature' && (
                      <SwiperSlide
                        key={`slide-offer-${key}}`}
                        style={{ textAlign: 'none !important' }}
                      >
                        <Step2BuyerSignaturePendingAgent
                          isAgentDashboard={isAgentDashboard}
                          bannerDetails={item}
                          AgentGroupCall={getBannerData}
                        />
                      </SwiperSlide>
                    )}
                </div>
              );
            })}
            {Object.entries(bannerData)?.map(([key, item]) => {
              return (
                <div key={`section-${key}`}>
                  {!signedContractBannerClose.includes(
                    Number(item?.propertyId)
                  ) &&
                    item?.isWinner == 1 &&
                    item?.isPropertyArchived == 0 &&
                    item?.isWinnerContractSignStatus == 'Completed' &&
                    item?.isBuyerContractSignedClosed == 0 && (
                      <SwiperSlide
                        key={`slide-offer-${key}}`}
                        style={{ textAlign: 'none !important' }}
                        id={'Agent_Buyer_Signed_The_Contract_Of_Sale'}
                      >
                        <Step3BuyerSignedContractAgentBanner
                          isAgentDashboard={isAgentDashboard}
                          bannerDetails={item}
                          AgentGroupCall={getBannerData}
                          pauseBannerBuyer={pauseBannerBuyer}
                          setSignedContractBannerClose={
                            setSignedContractBannerClose
                          }
                        />
                      </SwiperSlide>
                    )}
                </div>
              );
            })}
            {Object.entries(bannerData)?.map(([key, item]) => {
              return (
                <div key={`section-${key}`}>
                  {item?.isWinner == 1 &&
                    item?.vendorEsignStatus == null &&
                    item?.isPropertyArchived == 0 && (
                      <SwiperSlide
                        key={`slide-offer-${key}}`}
                        style={{ textAlign: 'none !important' }}
                      >
                        <Step4VendorContractESignNowAgent
                          isAgentDashboard={isAgentDashboard}
                          bannerDetails={item}
                          AgentGroupCall={getBannerData}
                        />
                      </SwiperSlide>
                    )}
                </div>
              );
            })}
            {Object.entries(bannerData).map(([key, property]) => {
              const isAllOwnersCompleted = (
                property?.propertyOwnerDetails ?? []
              ).every(
                (owner) => owner?.user?.vendorEsignStatus === 'Completed'
              );

              return (
                !isAllOwnersCompleted &&
                property?.isWinner === 1 &&
                property?.isPropertyArchived === 0 &&
                property?.vendorEsignStatus !== null && (
                  <SwiperSlide key={property.propertyId}>
                    <Step5VendorSignaturePendingAgent
                      bannerDetails={property}
                      isAgentDashboard={isAgentDashboard}
                      AgentGroupCall={getBannerData}
                    />
                  </SwiperSlide>
                )
              );
            })}
            {Object.entries(bannerData)?.map(([key, item]) => (
              <div key={`section-${key}`}>
                {item?.isPropertyArchived == 0 &&
                  item?.propertyOwnerDetails
                    ?.filter(
                      (owner) =>
                        owner?.user?.vendorEsignStatus === 'Completed' &&
                        owner?.user?.isVendorContractSignedClosed == 0
                    )
                    .map(
                      (owner) =>
                        !vendorSignedContractClose?.includes(
                          Number(owner?.user?.userId)
                        ) && (
                          <SwiperSlide
                            key={`slide-offer-${item.propertyId}-${owner.user.userId}`}
                            style={{ textAlign: 'none !important' }}
                            id="Agent_Vendor_Signed_The_Contract_Of_Sale"
                          >
                            <Step6VendorSignedContractOfSale
                              isAgentDashboard={isAgentDashboard}
                              bannerDetails={owner} // Property details
                              ownerDetails={owner} // Current owner
                              AgentGroupCall={getBannerData}
                              pauseBannerVendor={pauseBannerVendor}
                              propertyAddress={item.propertyAddress}
                              propertyId={item.propertyId}
                              isAgentVendorContractViewedCompleted={
                                item.isAgentVendorContractViewedCompleted
                              }
                              setVendorSignedContractClose={
                                setVendorSignedContractClose
                              }
                            />
                          </SwiperSlide>
                        )
                    )}
              </div>
            ))}
            {Object.entries(bannerData)?.map(([key, item]) => {
              return (
                <div key={`section-${key}`}>
                  {!outstandingBannerClose.includes(Number(item?.propertyId)) &&
                    item?.isWinner == 1 &&
                    item?.isPropertyArchived == 0 &&
                    item?.isWinnerDepositStatus !== 'Completed' &&
                    item?.isWinnerDepositStatus !== 'Processing' &&
                    item?.isWinnerDepositClosed == 0 && (
                      <SwiperSlide
                        key={`slide-offer-${key}}`}
                        style={{ textAlign: 'none !important' }}
                      >
                        <DepositPaymentOutstandingBanner
                          isAgentDashboard={isAgentDashboard}
                          bannerDetails={item}
                          AgentGroupCall={getBannerData}
                          profileDetails={profileDetails}
                          setOutstandingBannerClose={setOutstandingBannerClose}
                        />
                      </SwiperSlide>
                    )}
                </div>
              );
            })}

            {Object.entries(bannerData)?.map(([key, value]) => {
              return (
                value?.depositPaymentStatus && (
                  <div key={`section-${key}`}>
                    {value?.isPropertyArchived === 0 &&
                      !value.depositPaymentStatus &&
                      value.depositPaymentStatus
                        ?.filter(
                          (item) =>
                            item.status === 'Processing' ||
                            item.status === 'Processed'
                        )
                        ?.map((item, index) => (
                          <SwiperSlide
                            key={`slide-offer-${key}-${index}`}
                            style={{ textAlign: 'none !important' }}
                          >
                            <DepositPaymentReceivedBannerAgent
                              isAgentDashboard={isAgentDashboard}
                              bannerDetails={item}
                              AgentGroupCall={getBannerData}
                              confirmDeposit={confirmDeposit}
                              setConfirmDeposit={setConfirmDeposit}
                            />
                          </SwiperSlide>
                        ))}
                  </div>
                )
              );
            })}
            {Object.entries(bannerData)?.map(([key, item]) => {
              return (
                <div key={`section-${key}`}>
                  {(item?.cancelActionDetails == null ||
                    (item?.cancelActionDetails != null &&
                      exchangedTimeCalc(
                        item?.cancelActionDetails?.resumeAt
                      ))) &&
                    item?.isWinner == 1 &&
                    item?.isPropertyArchived == 0 &&
                    item?.isWinnerContractSignStatus == 'Completed' &&
                    item?.isWinnerDepositStatus == 'Completed' &&
                    item?.vendorEsignStatus == 'Completed' &&
                    item?.isExchangedStatus == null && (
                      <SwiperSlide
                        key={`slide-offer-${key}}`}
                        style={{ textAlign: 'none !important' }}
                      >
                        <ConfirmExchangeComplete
                          isAgentDashboard={isAgentDashboard}
                          bannerDetails={item}
                          AgentGroupCall={getBannerData}
                          proeprtyID={item?.propertyId}
                        />
                      </SwiperSlide>
                    )}
                </div>
              );
            })}

            {Object.entries(bannerData)?.map(([key, item]) => {
              const canShow =
                settlementVisibility[key] &&
                item?.exchangedStatus?.status === 'Exchanged' &&
                item?.isPropertyArchived == 0;

              if (!canShow) return null;

              return (
                <SwiperSlide
                  key={`slide-offer-${key}}`}
                  style={{ textAlign: 'none !important' }}
                >
                  <ConfirmSettlementCompleted
                    isAgentDashboard={isAgentDashboard}
                    bannerDetails={item}
                    AgentGroupCall={getBannerData}
                    proeprtyID={item?.propertyId}
                  />
                </SwiperSlide>
              );
            })}

            {Object.entries(bannerData)?.map(([key, item]) => {
              return (
                <div key={`section-${key}`}>
                  {!congratulationsettlementClose.includes(
                    Number(item?.propertyId)
                  ) &&
                    item?.exchangedStatus?.status == 'Settlement' &&
                    item?.isSettlementViewClosed == 0 && (
                      <SwiperSlide
                        key={`slide-offer-${key}}`}
                        style={{ textAlign: 'none !important' }}
                      >
                        <CongratulationSettlementCompleted
                          isAgentDashboard={isAgentDashboard}
                          bannerDetails={item}
                          AgentGroupCall={getBannerData}
                          setCongratulationsettlementClose={
                            setCongratulationsettlementClose
                          }
                        />
                      </SwiperSlide>
                    )}
                </div>
              );
            })}
          </>
        )}

        {/* ------------- Individual Banners -------------- */}

        {isAgentIndividual && (
          <>
            {!requestEsignBannerClose.includes(Number(bannerData?.buyerId)) &&
              bannerData?.isPropertyArchived == 0 &&
              bannerData?.eSignRequestStatus
                ?.filter(
                  (item) =>
                    item?.status === 'Requested' &&
                    item?.isTodayEsignRequestedViewed == 0
                )
                ?.map((item, index) => (
                  <SwiperSlide
                    key={`slide-offer-${index}}`}
                    style={{ borderRadius: '20px' }}
                  >
                    <RequestedESignContract
                      bannerDetails={item}
                      getListInfo={getListInfo}
                      setRequestEsignBannerClose={setRequestEsignBannerClose}
                    />
                  </SwiperSlide>
                ))}

            {bannerData?.stage == 'ST1' &&
              bannerData?.isPropertyArchived == 0 &&
              bannerData?.isApprovedLog == 1 &&
              bannerData?.timerStatus !== 'End' && (
                <SwiperSlide
                  key={`slide-offer-${bannerData.propertyId}`}
                  style={{ borderRadius: '20px' }}
                >
                  <StageTwoTimerCommencedAgent
                    bannerDetails={bannerData}
                    getListInfo={getListInfo}
                    setOpenCommenceStageTwo={setOpenCommenceStageTwo}
                  />
                </SwiperSlide>
              )}

            {(() => {
              // Common conditions
              const baseConditions =
                bannerData?.isWinner === 0 &&
                bannerData?.isPropertyArchived === 0 &&
                bannerData?.highestOffer !== null;

              // Stage 1 completed
              const isStage1Completed =
                bannerData?.stage === 'ST1' &&
                bannerData?.isApprovedLog === 1 &&
                bannerData?.timerStatus === 'End';

              // Stage 2 ended
              const isStage2Ended =
                bannerData?.stage === 'ST2' &&
                bannerData?.timerStatus === 'End';

              if (baseConditions && (isStage1Completed || isStage2Ended)) {
                return (
                  <SwiperSlide
                    key={`slide-offer-${bannerData.propertyId}`}
                    style={{ borderRadius: '20px' }}
                  >
                    <WinnerPendingBannerAgent
                      bannerDetails={bannerData}
                      getListInfo={getListInfo}
                      setOpenFromBannerNominateWinner={
                        setOpenFromBannerNominateWinner
                      }
                      setRequestdeposit={setRequestdeposit}
                      setDepositdetails={setDepositdetails}
                      isRequestDepositCompleted={isRequestDepositCompleted}
                      AgentGroupCall={getBannerData}
                    />
                  </SwiperSlide>
                );
              }

              return null;
            })()}

            {bannerData?.isWinner == 1 &&
              bannerData?.isPropertyArchived == 0 &&
              (bannerData?.isWinnerContractSignStatus == 'Action Required' ||
                bannerData?.isWinnerContractSignStatus == 'Requested') && (
                <SwiperSlide
                  key={`slide-offer-${bannerData.propertyId}`}
                  style={{ borderRadius: '20px' }}
                >
                  <Step1PrepareContractESign
                    bannerDetails={bannerData}
                    getListInfo={getListInfo}
                    AgentGroupCall={getBannerData}
                  />
                </SwiperSlide>
              )}
            {bannerData?.isWinner == 1 &&
              bannerData?.isPropertyArchived == 0 &&
              bannerData?.isWinnerContractSignStatus ==
                'Pending Buyer Signature' && (
                <SwiperSlide
                  key={`slide-offer-${bannerData.propertyId}`}
                  style={{ borderRadius: '20px' }}
                >
                  <Step2BuyerSignaturePendingAgent
                    bannerDetails={bannerData}
                    getListInfo={getListInfo}
                    AgentGroupCall={getBannerData}
                  />
                </SwiperSlide>
              )}
            {!signedContractBannerClose.includes(
              Number(bannerData?.propertyId)
            ) &&
              bannerData?.isWinner == 1 &&
              bannerData?.isPropertyArchived == 0 &&
              bannerData?.isWinnerContractSignStatus == 'Completed' &&
              bannerData?.isBuyerContractSignedClosed == 0 && (
                <SwiperSlide
                  key={`slide-offer-${bannerData.propertyId}`}
                  style={{ borderRadius: '20px' }}
                  id={'Agent_Buyer_Signed_The_Contract_Of_Sale'}
                >
                  <Step3BuyerSignedContractAgentBanner
                    bannerDetails={bannerData}
                    getListInfo={getListInfo}
                    pauseBannerBuyer={pauseBannerBuyer}
                    AgentGroupCall={getBannerData}
                    setSignedContractBannerClose={setSignedContractBannerClose}
                  />
                </SwiperSlide>
              )}
            {bannerData?.isWinner == 1 &&
              bannerData?.isPropertyArchived == 0 &&
              bannerData?.vendorEsignStatus == null && (
                <SwiperSlide
                  key={`slide-offer-${bannerData.propertyId}`}
                  style={{ borderRadius: '20px' }}
                >
                  <Step4VendorContractESignNowAgent
                    bannerDetails={bannerData}
                    getListInfo={getListInfo}
                    AgentGroupCall={getBannerData}
                  />
                </SwiperSlide>
              )}
            {!shouldShowBannerIndividual &&
              bannerData?.isWinner == 1 &&
              bannerData?.isPropertyArchived == 0 &&
              bannerData?.vendorEsignStatus !== null && (
                <SwiperSlide
                  key={`slide-offer-${bannerData?.propertyId}`}
                  style={{ borderRadius: '20px' }}
                >
                  <Step5VendorSignaturePendingAgent
                    bannerDetails={bannerData}
                    getListInfo={getListInfo}
                    AgentGroupCall={getBannerData}
                  />
                </SwiperSlide>
              )}
            {!vendorSignedContractClose.includes(
              Number(bannerData?.propertyId)
            ) &&
              bannerData?.isPropertyArchived == 0 &&
              bannerData?.propertyOwnerDetails
                ?.filter(
                  (owner) =>
                    owner?.user?.vendorEsignStatus === 'Completed' &&
                    owner?.user?.isVendorContractSignedClosed == 0
                )
                .map((owner) => (
                  <SwiperSlide
                    key={`slide-offer-${bannerData.propertyId}-${owner.user.userId}`}
                    style={{ borderRadius: '20px' }}
                    id="Agent_Vendor_Signed_The_Contract_Of_Sale"
                  >
                    <Step6VendorSignedContractOfSale
                      bannerDetails={owner}
                      ownerDetails={owner} // Current owner
                      getListInfo={getListInfo}
                      pauseBannerVendor={pauseBannerVendor}
                      AgentGroupCall={getBannerData}
                      propertyAddress={bannerData?.propertyAddress}
                      propertyId={bannerData?.propertyId}
                      isAgentVendorContractViewedCompleted={
                        bannerData?.isAgentVendorContractViewedCompleted
                      }
                      setVendorSignedContractClose={
                        setVendorSignedContractClose
                      }
                    />
                  </SwiperSlide>
                ))}
            {!outstandingBannerClose.includes(Number(bannerData?.propertyId)) &&
              bannerData?.isWinner == 1 &&
              bannerData?.isPropertyArchived == 0 &&
              bannerData?.isWinnerDepositStatus !== 'Completed' &&
              bannerData?.isWinnerDepositStatus !== 'Processing' &&
              bannerData?.isWinnerDepositClosed == 0 && (
                <SwiperSlide
                  key={`slide-offer-${bannerData.propertyId}`}
                  style={{ borderRadius: '20px' }}
                >
                  <DepositPaymentOutstandingBanner
                    bannerDetails={bannerData}
                    getListInfo={getListInfo}
                    profileDetails={profileDetails}
                    AgentGroupCall={getBannerData}
                    setOutstandingBannerClose={setOutstandingBannerClose}
                  />
                </SwiperSlide>
              )}

            {bannerData?.isPropertyArchived === 0 &&
              bannerData?.depositPaymentStatus
                ?.filter(
                  (item) =>
                    item.status === 'Processing' || item.status === 'Processed'
                )
                ?.map((item, index) => (
                  <SwiperSlide
                    key={`slide-offer-${index}}`}
                    style={{ borderRadius: '20px' }}
                  >
                    <DepositPaymentReceivedBannerAgent
                      profileDetailItem={item}
                      getListInfo={getListInfo}
                      bannerDetails={item}
                      confirmDeposit={confirmDeposit}
                      setConfirmDeposit={setConfirmDeposit}
                      profileDetails={profileDetails}
                    />
                  </SwiperSlide>
                ))}

            {(bannerData?.cancelActionDetails == null ||
              (bannerData?.cancelActionDetails != null &&
                exchangedTimeCalc(
                  bannerData?.cancelActionDetails?.resumeAt
                ))) &&
              bannerData?.isPropertyArchived == 0 &&
              bannerData?.isWinner == 1 &&
              bannerData?.isWinnerContractSignStatus == 'Completed' &&
              bannerData?.isWinnerDepositStatus == 'Completed' &&
              bannerData?.vendorEsignStatus == 'Completed' &&
              bannerData?.isExchangedStatus == null && (
                <SwiperSlide
                  key={`slide-offer-${bannerData.propertyId}`}
                  style={{ borderRadius: '20px' }}
                >
                  <ConfirmExchangeComplete
                    bannerDetails={bannerData}
                    getListInfo={getListInfo}
                    setOpenExchange={setOpenExchange}
                    setShowExchange={setShowExchange}
                  />
                </SwiperSlide>
              )}

            {calculatedTime &&
              bannerData?.exchangedStatus?.status == 'Exchanged' &&
              bannerData?.isPropertyArchived == 0 && (
                <SwiperSlide
                  key={`slide-offer-${bannerData.propertyId}`}
                  style={{ borderRadius: '20px' }}
                >
                  <ConfirmSettlementCompleted
                    bannerDetails={bannerData}
                    getListInfo={getListInfo}
                    setShowSettlement={setShowSettlement}
                    setOpenSettlement={setOpenSettlement}
                  />
                </SwiperSlide>
              )}
            {!congratulationsettlementClose.includes(
              Number(bannerData?.propertyId)
            ) &&
              bannerData?.exchangedStatus?.status == 'Settlement' &&
              bannerData?.isSettlementViewClosed == 0 && (
                <SwiperSlide
                  key={`slide-offer-${bannerData.propertyId}`}
                  style={{ borderRadius: '20px' }}
                >
                  <CongratulationSettlementCompleted
                    bannerDetails={bannerData}
                    setCongratulationsettlementClose={
                      setCongratulationsettlementClose
                    }
                  />
                </SwiperSlide>
              )}
          </>
        )}
      </Swiper>

      {depositdetails && (
        <DetailsPopup
          openDetailsPopup={depositdetails}
          handleCloseDetails={() => {
            setDepositdetails(false);
          }}
          profileDetails={profileDetails}
          buyerId={buyerId}
          isFromBuyerRegister={true}
          getListInfo={getListInfo}
        />
      )}
      {requestdeposit && (
        <Requestdeposit
          requestdeposit={requestdeposit}
          endPropertyPopupFromNominateWinner={
            endPropertyPopupFromNominateWinner
          }
          setRequestdeposit={setRequestdeposit}
          setReqDepositOpen={setReqDepositOpen}
          selectedrowbuyerid={buyerId}
          getListInfo={getListInfo}
          highestOfferBuyerId={bannerData?.highestOfferBuyerId}
          selectedrowbuyername={selectedrowbuyername}
          row={matchedBuyer}
          reqDepositOpen={reqDepositOpen}
          address={profileDetails?.PropertyDetails?.propertyAddress?.streetName}
          depositRes={matchedBuyer?.buyerOfferDetails?.depositPaymentLog}
          setEndPropertyPopupFromNominateWinner={
            setEndPropertyPopupFromNominateWinner
          }
          profileDetails={profileDetails}
          fromWinnerPendingBanner={true}
        />
      )}
    </>
  );
};

export default IndexAgentBanners;
